import { render, staticRenderFns } from "./BoxValoresRepresentante.vue?vue&type=template&id=2d037770&lang=html&"
import script from "./BoxValoresRepresentante.vue?vue&type=script&lang=js&"
export * from "./BoxValoresRepresentante.vue?vue&type=script&lang=js&"
import style0 from "./BoxValoresRepresentante.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/dashboard/cadeia/orcamento/BoxValoresRepresentante.vue
// module id = 1191
// module chunks = 28